import {
  ProposalMetricsDatesReducerState,
  ProposalMetricsState,
  ProposalPriceSettingsState,
} from './types';

// Initial States
export const initialState: ProposalPriceSettingsState = {
  proposal: null,
  assignmentInProgress: false,
};

export const initialStateProposalMetric: ProposalMetricsState = {
  count: 0,
};

export const initialStateProposalMetricsDates: ProposalMetricsDatesReducerState = {
  startDate: '',
  endDate: '',
};
